import React from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Typography } from "antd";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
      width: "100%",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

const PaymentSection = ({ titleLevel, setPaymentSectionIconStatus }) => {
  return (
    <>
      <CheckoutForm
        titleLevel={titleLevel}
        setPaymentSectionIconStatus={setPaymentSectionIconStatus}
      />
    </>
  );
};

const CheckoutForm = ({ titleLevel, setPaymentSectionIconStatus }) => {
  const handleCardElementChange = (e) => {
    if (e?.complete) {
      setPaymentSectionIconStatus(true);
    } else {
      setPaymentSectionIconStatus(false);
    }
  };

  return (
    <div>
      <label>
        <Typography.Title level={titleLevel.sub} style={{ paddingTop: 20 }}>
          Card Details
        </Typography.Title>
      </label>
      <div>
        <CardElement
          options={CARD_ELEMENT_OPTIONS}
          onChange={handleCardElementChange}
        />
      </div>
    </div>
  );
};

export default PaymentSection;
